import React from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import { NavLink } from 'react-router-dom';

var bnrimg = require('./../../images/banner/4.jpg');

class Invest extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          <Banner title="Invest with JMR GROUP" pagename="Investment" bgimage={bnrimg} />

          <div className="section-full p-t80 p-b80 inner-page-padding">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-md-7">
                  <div className="section-head">
                    <div className="mt-separator-outer separator-left">
                      <div className="mt-separator">
                        <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Why</span> Invest</h2>
                      </div>
                    </div>
                  </div>

                  <div className="mt-box m-b30">
                    <h3 className="font-weight-600">Choosing JMR GROUP means investing with a brand built on trust, transparency, and long‑term value.</h3>
                    <p>With 30+ years of experience, clear‑titled land, and a proven legacy of developing over 1,500 acres and delivering 500+ acres of premium projects, JMR GROUP ensures quality, security, and timely delivery through efficient planning and in‑house machinery.</p>
                    <p>Located in one of India’s fastest‑growing real estate markets, Hyderabad continues to thrive with IT expansion, infrastructure growth, and urban development. The Warangal Highway Integrated Township stands out as a high‑potential corridor, driven by the upcoming ISKCON Temple, 6‑lane national highway expansion, proximity to AIIMS Hospital, and rising demand for metro‑approved lifestyle spaces.</p>
                    <p>Investing with JMR GROUP guarantees transparency, strong appreciation, and a clear exit strategy — making it a future‑proof real estate investment backed by expert architects, engineers, and construction teams delivering future‑ready projects.</p>
                  </div>

                  <div className="mt-box bg-white p-30">
                    <h4 className="m-b20">Investment Highlights</h4>
                    <ul className="list-unstyled">
                      <li>• 30+ years of land acquisition &amp; development experience</li>
                      <li>• 1,500+ acres acquired; 500+ acres developed</li>
                      <li>• In‑house machinery for faster execution &amp; quality control</li>
                      <li>• Projects in high growth corridors with strong appreciation potential</li>
                      <li>• Transparent processes and exit strategies for investors</li>
                    </ul>
                  </div>
                </div>

                <div className="col-lg-4 col-md-5">
                  <div className="widget bg-white p-a30">
                    <h4 className="m-b15">Contact our Sales</h4>
                    <p><strong>Phone:</strong> 8977500219</p>
                    <p><strong>Email:</strong> <a href="mailto:jmrgroup123@gmail.com">jmrgroup123@gmail.com</a></p>
                    <NavLink to={'/contactus'} className="site-button btn-effect"><span>Get in touch</span></NavLink>
                  </div>

                  <div className="mt-box bg-white p-30 m-t30">
                    <h5 className="m-b15">Investor Advantages</h5>
                    <div className="row">
                      <div className="col-12 m-b20">
                        <i className="fa fa-shield text-primary" /> <strong>Clear Titles</strong>
                        <p className="m-t5">All lands are clear‑titled with legal due diligence.</p>
                      </div>
                      <div className="col-12 m-b20">
                        <i className="fa fa-industry text-primary" /> <strong>Own Machinery</strong>
                        <p className="m-t5">In‑house equipment ensures speed and strict QC.</p>
                      </div>
                      <div className="col-12 m-b20">
                        <i className="fa fa-road text-primary" /> <strong>Strategic Locations</strong>
                        <p className="m-t5">Focused on corridors with strong infra tailwinds.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="section-head m-t40">
                <div className="mt-separator-outer separator-left">
                  <div className="mt-separator">
                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Key</span> Benefits</h2>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 col-sm-6 m-b30">
                  <div className="icon-bx-wraper left p-a20 bg-white">
                    <div className="icon-md text-primary"><i className="fa fa-map" /></div>
                    <div className="icon-content">
                      <h5 className="m-b5">Strategic Land Holdings</h5>
                      <p>Large clear‑titled land banks across growth corridors.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6 m-b30">
                  <div className="icon-bx-wraper left p-a20 bg-white">
                    <div className="icon-md text-primary"><i className="fa fa-cogs" /></div>
                    <div className="icon-content">
                      <h5 className="m-b5">Execution Strength</h5>
                      <p>In‑house construction &amp; machinery for reliable delivery.</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-6 m-b30">
                  <div className="icon-bx-wraper left p-a20 bg-white">
                    <div className="icon-md text-primary"><i className="fa fa-users" /></div>
                    <div className="icon-content">
                      <h5 className="m-b5">Trusted Team</h5>
                      <p>Experienced leadership in acquisitions, development &amp; delivery.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </>
    );
  }
}

export default Invest;
